import { render, staticRenderFns } from "./Step10.vue?vue&type=template&id=7fe77e8a&scoped=true"
import script from "./Step10.vue?vue&type=script&lang=js"
export * from "./Step10.vue?vue&type=script&lang=js"
import style0 from "./Step10.vue?vue&type=style&index=0&id=7fe77e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe77e8a",
  null
  
)

export default component.exports